import { render, staticRenderFns } from "./flagged-costs-form-overview-year-display.vue?vue&type=template&id=45b648fc&scoped=true"
import script from "./flagged-costs-form-overview-year-display.vue?vue&type=script&lang=ts"
export * from "./flagged-costs-form-overview-year-display.vue?vue&type=script&lang=ts"
import style0 from "./flagged-costs-form-overview-year-display.vue?vue&type=style&index=0&id=45b648fc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b648fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b648fc')) {
      api.createRecord('45b648fc', component.options)
    } else {
      api.reload('45b648fc', component.options)
    }
    module.hot.accept("./flagged-costs-form-overview-year-display.vue?vue&type=template&id=45b648fc&scoped=true", function () {
      api.rerender('45b648fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cost-exclusion-step/flagged-costs-lightbox/flagged-costs-form/flagged-costs-form-overview-year-display.vue"
export default component.exports